export const actionType = {
  GET_QA_PAGE_DATA_REQUEST:  'GET_QA_PAGE_DATA_REQUEST',
  GET_QA_PAGE_DATA_RECEIVED: 'GET_QA_PAGE_DATA_RECEIVED',
  QUESTION_LIST_REQUEST: 'QUESTION_LIST_REQUEST',
  QUESTION_LIST_SUCCESS: 'QUESTION_LIST_SUCCESS',
  QUESTION_LIST_FAILURE: 'QUESTION_LIST_FAILURE' 
}

/**
 *  @getProductCategories method to get the product category for search page listing
 *  @input: null
 *  @output: json object of categories
 */
export const getPageDataAction = () => ({
  type: actionType.GET_QA_PAGE_DATA_REQUEST
});


/**
 * @getQuestionListAction method to get the question list as per query selection
 * @input: queryId
 * @output: Object of questions
 */
export const getQuestionListAction = (queryId) => ({
  type: actionType.QUESTION_LIST_REQUEST, payload:queryId
})